// 该文件专门用于创建整个应用的路由器
import VueRouter from 'vue-router'
//引入组件
import index from '../view/index.vue'
import phb from '../view/phb.vue'
import phbDetail from '../view/phbDetail.vue'

import Cookies from "js-cookie";

//创建并暴露一个路由器
const router =  new VueRouter({
	mode: 'history',
	base: '/2025filmreview/',
	routes:[
		// {
		// 	path:'/',
		// 	redirect: '/index'
		// },
		{
		  path: '/',
		  name: '',
		  component: index
		},
		{
			name:'index',
			path:'/index',
			component:index
		},
		{
			name:'phb',
			path:'/phb',
			component:phb
		},
		{
			name:'phbDetail',
			path:'/phbDetail',
			component:phbDetail
		}
		
	]
})
// 路由拦截
router.beforeEach((to, from, next) => {
	
  next();
});


export default router;
